export default __webpack_public_path__ + "static/media/PenguinSmart_Logo_BIL_SCN_Vertical_Black.2a462db2.jpg";